import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ShieldCheckIcon, CreditCardIcon, ZapIcon, ClockIcon, CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingCard() {
  return <section id="pricing" className="py-10 sm:py-14 px-4 relative scroll-mt-10 bg-brand-surface" data-id="element-158">
      <div className="max-w-md sm:max-w-lg mx-auto relative z-10" data-id="element-159">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-8 text-brand-navy" data-id="element-160">
          Das Angebot
        </motion.h2>

        {/* Main Offer */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white border border-brand-gold/40 rounded-3xl relative shadow-xl mb-10" data-id="element-161">
          {/* Badge */}
          <div className="flex justify-center -mt-4 mb-2" data-id="element-162">
            <div className="bg-brand-gold text-white font-black px-5 py-1.5 rounded-full flex items-center gap-1.5 uppercase tracking-wide text-xs shadow-md" data-id="element-163">
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-164" />
              DIE BELIEBTESTE WAHL
            </div>
          </div>

          <div className="p-6 sm:p-8" data-id="element-165">
            <div className="space-y-0 mb-5" data-id="element-166">
              {[{
              label: 'Tomo 1: Biomechanischer Atlas',
              price: '97 CHF'
            }, {
              label: 'Tomo 2: Technical Field Deck 20 Karten',
              price: '77 CHF'
            }, {
              label: 'Tomo 3: Performance Tracking System',
              price: '67 CHF'
            }, {
              label: 'Tomo 4: VIP-Protokoll Code',
              price: '87 CHF'
            }, {
              label: 'Bonus 1: Quadrilingüales Lexikon',
              price: '37 CHF'
            }, {
              label: 'Bonus 2: Wetter und Sicherheits-Guide',
              price: '47 CHF'
            }, {
              label: 'Bonus 3: Checklisten-System 18 Karten',
              price: '33 CHF'
            }].map((item, i) => <div key={i} className="flex justify-between items-center border-b border-brand-border py-3 gap-3" data-id="element-167">
                  <span className="text-brand-text font-medium text-xs sm:text-sm" data-id="element-168">
                    {item.label}
                  </span>
                  <span className="text-brand-muted line-through text-sm shrink-0" data-id="element-169">
                    {item.price}
                  </span>
                </div>)}
              <div className="flex justify-between items-center pt-4" data-id="element-170">
                <span className="text-sm sm:text-base font-black text-brand-navy uppercase" data-id="element-171">
                  REALER WERT:
                </span>
                <span className="text-xl sm:text-2xl font-black text-brand-red line-through" data-id="element-172">
                  445.00 CHF
                </span>
              </div>
            </div>

            {/* Discount badge */}
            <div className="flex justify-center mb-4" data-id="element-173">
              <div className="bg-red-50 border border-brand-red/20 text-brand-red font-black px-4 py-1.5 rounded-full text-xs uppercase tracking-wide" data-id="element-174">
                89% RABATT
              </div>
            </div>

            {/* Inner offer card */}
            <div className="bg-brand-surface border border-brand-gold/30 rounded-2xl p-5 text-center mb-5" data-id="element-175">
              <div className="flex justify-center items-center gap-2 mb-2" data-id="element-176">
                <span className="text-4xl sm:text-5xl font-black text-brand-navy" data-id="element-177">
                  47.90 CHF
                </span>
              </div>
              <p className="text-xs text-brand-muted mt-2 font-medium" data-id="element-178">
                💳 Einmalzahlung • ⚡ Sofortiger Zugang
              </p>
            </div>

            {/* Salirà presto pill */}
            <div className="flex justify-center mb-5" data-id="element-179">
              <div className="inline-flex items-center gap-2 border border-brand-red/20 bg-red-50 px-4 py-1.5 rounded-full" data-id="element-180">
                <ClockIcon className="w-4 h-4 text-brand-red" data-id="element-181" />
                <span className="text-xs font-bold text-brand-red" data-id="element-182">
                  Sonderpreis zum Launch — steigt bald
                </span>
              </div>
            </div>

            <CTAButton href="https://suiza.kitonline.shop/cart/44668477210759:1" className="w-full mb-5" data-id="element-183">
              JA! ICH WILL DAS KOMPLETT-SYSTEM
            </CTAButton>
          </div>
        </motion.div>

        {/* Upsell Offer */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-brand-navy text-white border border-brand-navyDark rounded-3xl relative shadow-2xl" data-id="element-184">
          {/* Badge */}
          <div className="flex justify-center -mt-4 mb-2" data-id="element-185">
            <div className="bg-brand-gold text-white font-black px-5 py-1.5 rounded-full flex items-center gap-1.5 uppercase tracking-wide text-xs shadow-md" data-id="element-186">
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-187" />
              SEHR EMPFOHLEN
            </div>
          </div>

          <div className="p-6 sm:p-8 text-center" data-id="element-188">
            <h3 className="text-xl sm:text-2xl font-black mb-2" data-id="element-189">
              Swiss Elite Academy System 🏆
            </h3>
            <p className="text-sm text-brand-goldLight font-bold mb-6" data-id="element-190">
              Das vollständige Skalierungssystem:
            </p>

            <ul className="text-sm text-gray-300 space-y-2 mb-6 text-left max-w-xs mx-auto" data-id="element-191">
              <li className="flex items-center gap-2" data-id="element-192">
                <CheckIcon className="w-4 h-4 text-brand-gold" data-id="element-193" /> Junior Pro
                Method 20 Gamification-Drills
              </li>
              <li className="flex items-center gap-2" data-id="element-194">
                <CheckIcon className="w-4 h-4 text-brand-gold" data-id="element-195" /> 100
                Feedback-Masterbank
              </li>
              <li className="flex items-center gap-2" data-id="element-196">
                <CheckIcon className="w-4 h-4 text-brand-gold" data-id="element-197" />{' '}
                Business-Architektur
              </li>
              <li className="flex items-center gap-2" data-id="element-198">
                <CheckIcon className="w-4 h-4 text-brand-gold" data-id="element-199" />{' '}
                Retainer-Vertragsvorlagen
              </li>
              <li className="flex items-center gap-2" data-id="element-200">
                <CheckIcon className="w-4 h-4 text-brand-gold" data-id="element-201" />{' '}
                5-Jahres-Strategieplan
              </li>
            </ul>

            <p className="text-sm font-medium text-gray-300 italic mb-6" data-id="element-202">
              Von Einzelinstruktor zur Elite-Akademie.
            </p>

            <div className="flex justify-center items-end gap-3 mb-2" data-id="element-203">
              <span className="text-lg text-gray-400 line-through mb-1" data-id="element-204">
                297 CHF
              </span>
              <span className="text-3xl sm:text-4xl font-black text-white" data-id="element-205">
                67.90 CHF
              </span>
            </div>

            <div className="inline-block bg-brand-red/20 text-brand-redLight font-bold px-3 py-1 rounded-full text-xs mb-6" data-id="element-206">
              🔥 NUR HEUTE: Du sparst 229.10 CHF
            </div>

            <CTAButton href="https://suiza.kitonline.shop/cart/44668481896583:1" className="w-full mb-5 !bg-gradient-to-r !from-brand-gold !to-brand-goldLight !text-brand-navy !shadow-[0_0_25px_rgba(201,164,73,0.4)] hover:!shadow-[0_0_35px_rgba(201,164,73,0.6)]" data-id="element-207">
              JA! ICH WILL DAS ELITE ACADEMY SYSTEM
            </CTAButton>

            <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-[11px] sm:text-xs text-gray-400 font-medium" data-id="element-208">
              <span className="flex items-center gap-1" data-id="element-209">
                <ZapIcon className="w-3 h-3 text-brand-gold" data-id="element-210" /> Sofortiger
                Zugang
              </span>
              <span className="text-gray-600" data-id="element-211">•</span>
              <span className="flex items-center gap-1" data-id="element-212">
                <CreditCardIcon className="w-3 h-3 text-brand-gold" data-id="element-213" />{' '}
                Einmalzahlung
              </span>
              <span className="text-gray-600" data-id="element-214">•</span>
              <span className="flex items-center gap-1" data-id="element-215">
                <ShieldCheckIcon className="w-3 h-3 text-brand-gold" data-id="element-216" />{' '}
                7-Tage-Garantie
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}